import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import PieChart from './PieChart'

/**
 * Componente que muestra las tarjetas de estadísticas:
 * - Progreso (gráfico de dona + detalles)
 * - Tres tarjetas vacías para contenido futuro
 */
export const DatosCards = ({
  /** Flag para estado de carga de estadísticas */
  isLoadingStats,
  /** Datos de estadísticas (número de tipos, vinculados y progreso) */
  stats,
  /** Progreso animado (0 a 1) */
  currentProgress,
}) => {
  return (
    <div className="cards-container">
      {isLoadingStats ? (
        <div className="card">
          <Skeleton height={80} width="80%" />
          <Skeleton height={40} width="60%" style={{ marginTop: '1rem' }} />
        </div>
      ) : (
        <div className="card">
          <p className="card-title">Progreso</p>
          <div className="chart-container">
            <PieChart percentage={currentProgress} />
          </div>
          {stats ? (
            <>
              <p className="card-detail">
                <strong>Tipos:</strong> {stats.nTypes}
              </p>
              <p className="card-detail">
                <strong>Vinculados:</strong> {stats.nLinked}
              </p>
            </>
          ) : (
            <p>Cargando datos...</p>
          )}
        </div>
      )}
      {/* Tarjetas reservadas para métricas futuras */}
      <div className="card" />
      <div className="card" />
    </div>
  )
}

export default DatosCards
